import $ from 'jquery';

export default function getAdditionalPosts(args) {
  return $.ajax({
    url: window.ajaxurl,
    method: "GET",
    data: args || {},
    success: function(data) {
      return data;
    },
    error: function(xhr) {
      console.log(xhr);
    }
  });
}
